import { render, staticRenderFns } from "./pos-keyboard-v2.vue?vue&type=template&id=8372b3c8&scoped=true&"
import script from "./pos-keyboard-v2.vue?vue&type=script&lang=ts&"
export * from "./pos-keyboard-v2.vue?vue&type=script&lang=ts&"
import style0 from "./pos-keyboard-v2.vue?vue&type=style&index=0&id=8372b3c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8372b3c8",
  null
  
)

export default component.exports